// 判断是否为对象
export const isObject = obj => {
  return Object.prototype.toString.call(obj) === '[object Object]'
}
// 判断是否为对象
export const isNullObject = obj => {
  return JSON.stringify(obj) === '{}'
}
// 随机生成4位数验证码
export const verifyCanvas = str => {
  const nums = [
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    '0',
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'I',
    'J',
    'K',
    'L',
    'M',
    'N',
    'O',
    'P',
    'Q',
    'R',
    'S',
    'T',
    'U',
    'V',
    'W',
    'X',
    'Y',
    'Z',
    'a',
    'b',
    'c',
    'd',
    'e',
    'f',
    'g',
    'h',
    'i',
    'j',
    'k',
    'l',
    'm',
    'n',
    'o',
    'p',
    'q',
    'r',
    's',
    't',
    'u',
    'v',
    'w',
    'x',
    'y',
    'z',
  ]
  const canvas = document.createElement('canvas')
  const context = canvas.getContext('2d') // 获取画布2D上下文
  context.fillStyle = 'cornflowerblue' // 画布填充色
  context.fillRect(0, 0, canvas.width, canvas.height) // 清空画布
  context.fillStyle = 'white' // 设置字体颜色
  context.font = '80px Arial' // 设置字体
  const rand = []
  const x = []
  const y = []
  for (let i = 0; i < 4; i++) {
    rand.push(rand[i])
    rand[i] = nums[Math.floor(Math.random() * nums.length)]
    x[i] = i * 60 + 10
    y[i] = Math.random() * 10 + 80
    context.fillText(rand[i], x[i], y[i])
  }
  str = rand.join('').toUpperCase()
  // 画3条随机线
  for (let i = 0; i < 3; i++) {
    drawline(canvas, context)
  }

  // 画30个随机点
  for (let i = 0; i < 30; i++) {
    drawDot(canvas, context)
  }
  return canvas.toDataURL('image/png')
  function drawDot(canvas, context) {
    var px = Math.floor(Math.random() * canvas.width)
    var py = Math.floor(Math.random() * canvas.height)
    context.moveTo(px, py)
    context.lineTo(px + 1, py + 1)
    context.lineWidth = 0.2
    context.stroke()
  }
  function drawline(canvas, context) {
    context.moveTo(
      Math.floor(Math.random() * canvas.width),
      Math.floor(Math.random() * canvas.height),
    ) // 随机线的起点x坐标是画布x坐标0位置，y坐标是画布高度的随机数
    context.lineTo(
      Math.floor(Math.random() * canvas.width),
      Math.floor(Math.random() * canvas.height),
    ) // 随机线的终点x坐标是画布宽度，y坐标是画布高度的随机数
    context.lineWidth = 1 // 随机线宽
    context.strokeStyle = 'rgba(50,50,50,0.3)' // 随机线描边属性
    context.stroke() // 描边，即起点描到终点
  }
}

export const LS = {
  get(key) {
    const value = localStorage.getItem(key)
    if (value) {
      try {
        return JSON.parse(value)
      } catch (error) {
        return value
      }
    } else {
      return false
    }
  },
  set(key, value) {
    if (typeof value === 'object') {
      localStorage.setItem(key, JSON.stringify(value))
    } else {
      localStorage.setItem(key, value)
    }
  },
  remove(key) {
    localStorage.removeItem(key)
  },
  clear: function() {
    localStorage.clear()
  },
}

export const SS = {
  get(key) {
    const value = sessionStorage.getItem(key)
    if (value) {
      try {
        return JSON.parse(value)
      } catch (error) {
        return value
      }
    } else {
      return false
    }
  },
  set(key, value) {
    if (typeof value === 'object') {
      sessionStorage.setItem(key, JSON.stringify(value))
    } else {
      sessionStorage.setItem(key, value)
    }
  },
  remove(key) {
    sessionStorage.removeItem(key)
  },
  clear: function() {
    sessionStorage.clear()
  },
}

export const commonFun = {
  conver(s) {
    return s < 10 ? '0' + s : s
  },
  getCurDate() {
    const myDate = new Date()

    // 获取当前年
    const year = myDate.getFullYear()

    // 获取当前月
    const month = myDate.getMonth() + 1

    // 获取当前日
    const date = myDate.getDate()
    const h = myDate.getHours() // 获取当前小时数(0-23)
    const m = myDate.getMinutes() // 获取当前分钟数(0-59)
    const s = myDate.getSeconds()

    // 获取当前时间
    const day =
      year + '-' + commonFun.conver(month) + '-' + commonFun.conver(date)
    const hour =
      commonFun.conver(h) +
      ':' +
      commonFun.conver(m) +
      ':' +
      commonFun.conver(s)
    const now = day + ' ' + hour
    return {
      dayHour: now,
      day,
      hour,
    }
  },
  /**
   * @Title 是否为空判断
   * @Description TODO
   * @author xzd
   * @param val
   * @returns {Boolean} 空返回true
   */
  isEmpty(val) {
    if (typeof val === 'string' || val instanceof String) {
      val = val.replace(/\s/g, '')
    }
    if (val === null) {
      return 1
    }
    if (val === undefined || val === 'undefined') {
      return 1
    }
    if (val === '') {
      return 1
    }
    if (val.length === 0) {
      return 1
    }
    if (!/[^(^\s*)|(\s*$)]/.test(val)) {
      return 1
    }
    return 0
  },
  /**
   * @Title 判断obj对象是否没有属性
   * @Description 没有返回true
   * @param obj 只接收obj
   * @returns {boolean}
   */
  isEmptyProperty(obj) {
    let key
    for (key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        return 0 //  不为空返回false
      }
    }
    return 1 //  空返回true
  },
  // 获取当天的开始与结束日期
  GetTodayDate(addDate = 0, addTime = true) {
    var dd = new Date()
    dd.setDate(dd.getDate() + addDate) // 获取第addDate天后的日期
    var y = dd.getFullYear()
    var m =
      dd.getMonth() + 1 < 10 ? '0' + (dd.getMonth() + 1) : dd.getMonth() + 1 // 获取当前月份的日期，不足10补0
    var d = dd.getDate() < 10 ? '0' + dd.getDate() : dd.getDate() // 获取当前几号，不足10补0
    let start = y + '-' + m + '-' + d
    addTime ? (start = start + ' ' + '00:00:00') : ''
    let end = y + '-' + m + '-' + d
    addTime ? (end = end + ' ' + '23:59:59') : ''
    return [start, end]
  },

  // 获取n天前的时间
  GetBeforeTime() {},

  // 获取当天日期的前7天日期
  getBeforeDate(n, type = '-') {
    const d = new Date()
    let year = d.getFullYear()
    let mon = d.getMonth() + 1
    let day = d.getDate()
    if (day <= n) {
      if (mon > 1) {
        mon = mon - 1
      } else {
        year = year - 1
        mon = 12
      }
    }
    d.setDate(d.getDate() - n)
    year = d.getFullYear()
    mon = d.getMonth() + 1
    day = d.getDate()
    const s =
      year +
      type +
      (mon < 10 ? '0' + mon : mon) +
      type +
      (day < 10 ? '0' + day : day)
    return s
  },
  // 16进制颜色转换
  hexToRgb(hex) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
    return result
    // ? {/
    // r: parseInt(result[1], 16),
    // g: parseInt(result[2], 16),
    // b: parseInt(result[3], 16)
    // }
    // : null;
  },
  /**
   * 对象深拷贝
   */
  deepClone(data) {
    var type = this.getObjType(data)
    var obj
    if (type === 'array') {
      obj = []
    } else if (type === 'object') {
      obj = {}
    } else {
      // 不再具有下一层次
      return data
    }
    if (type === 'array') {
      for (var i = 0, len = data.length; i < len; i++) {
        delete data[i].$parent
        obj.push(this.deepClone(data[i]))
      }
    } else if (type === 'object') {
      for (var key in data) {
        delete data.$parent
        obj[key] = this.deepClone(data[key])
      }
    }
    return obj
  },
  getObjType(obj) {
    var toString = Object.prototype.toString
    var map = {
      '[object Boolean]': 'boolean',
      '[object Number]': 'number',
      '[object String]': 'string',
      '[object Function]': 'function',
      '[object Array]': 'array',
      '[object Date]': 'date',
      '[object RegExp]': 'regExp',
      '[object Undefined]': 'undefined',
      '[object Null]': 'null',
      '[object Object]': 'object',
    }
    if (obj instanceof Element) {
      return 'element'
    }
    return map[toString.call(obj)]
  },
}

export const initMeunList = meunList => {
  return filtrate(meunList)
  function filtrate(list) {
    const newList = list.filter(menuItem => {
      const { meta, children } = menuItem
      // console.log(meta);
      if (children && children.length !== 0) {
        menuItem.children = filtrate(children)
      }
      return !meta || !meta.meunHide
    })
    return newList
  }
}

export const initCacheList = meunList => {
  const cacheList = ['Layout']
  // filtrate(meunList);
  // function filtrate(list) {
  //   list.filter(menuItem => {
  //     const { meta, children } = menuItem;
  //     if (children && children.length !== 0) {
  //       menuItem.children = filtrate(children);
  //     } else if (!meta.notCache && menuItem.name) {
  //       cacheList.push(menuItem.name.replace(menuItem.name[0], menuItem.name[0].toUpperCase()))
  //     }
  //   })
  // }
  return cacheList
}

export const copyText = txt => {
  if (typeof txt !== 'string' || !txt.length) {
    return
  }
  let txtEl = document.createElement('input')
  txtEl.setAttribute('type', 'text')
  txtEl.setAttribute('value', txt)
  txtEl.style.position = 'fixed'
  txtEl.style.left = '-999999px'
  txtEl.style.top = '-9999px'
  document.body.appendChild(txtEl)
  txtEl.select()
  document.execCommand('copy')
  document.body.removeChild(txtEl)
  txtEl = null
}

// 金额格式化——显示千位分隔符
export function pricefmt (num) {
  if (!num) return '--'
  let str = num.toString()
  // 没有小数点时，在末尾补上一个小数点
  if (str.indexOf('.') === -1) {
    str += '.'
  }
  str = str.replace(/(\d)(?=(\d{3})+\.)/g, '$1,').replace(/\.$/, '')
  return str
}
